export enum UAPPerms {
  ACCOUNT_VIEW = 'UAPAccountView',
  ACCOUNT_VIEW_ALL = 'UAPViewAllAc',
  DOCUMENT_CONTRACTS_VIEW = 'UAPConView',
  DOCUMENT_SHARED_VIEW = 'UAPDocShdView',
  DOCUMENT_STATEMENT_VIEW = 'UAPAccStmtView',
  DOCUMENT_VIEW = 'UAPDocView',
  ENROLLMENT_ACT_EDIT = 'UAPEnrActEdit',
  ENROLLMENT_ACT_VIEW = 'UAPEnrActView',
  ENROLLMENT_EDIT = 'UAPEnrEdit',
  ENROLLMENT_VIEW = 'UAPEnrView',
  PORTAL_ADMIN = 'UAPPortAdmn',
  SERVICING_ACCOUNT_EDIT = 'UAPAccSvcEdit',
  SERVICING_ACCOUNT_VIEW = 'UAPAccSvcView',
  SERVICING_EDIT = 'UAPSvcEdit',
  SERVICING_REPORTING_EDIT = 'UAPRepSvcEdit',
  SERVICING_REPORTING_VIEW = 'UAPRepSvcView',
  SERVICING_TRADING_EDIT = 'UAPTraSvcEdit',
  SERVICING_TRADING_VIEW = 'UAPTraSvcView',
  SERVICING_VIEW = 'UAPSvcView',
  TEMPLATE_EDIT = 'UAPEnrTemplEdit',
}
